import { OPEN_POPUP, CLOSE_POPUP } from 'constants/actionTypes';
import { FORGOT_PASSWORD } from 'constants/popups';

const defaultState = {
  [FORGOT_PASSWORD]: false,
};

function popupReducer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_POPUP:
      return {
        ...state,
        [action.payload]: {
          isOpen: true,
          params: action.params,
        },
      };
    case CLOSE_POPUP:
      return {
        ...state,
        [action.payload]: false,
      };
    default:
      return state;
  }
}

export default popupReducer;
